module.exports = __webpack_public_path__ + "static/img/draw-bg.a029145f.png";